import { get, includes } from 'lodash';

export const hasLoadedHomepage = (state, clubId) =>
  includes(get(state, 'homepage.hasLoaded', []), clubId);

export const isLoadingHomepage = (state, clubId) =>
  includes(get(state, 'homepage.currentlyLoading', []), clubId);

export const getHomepageData = (state, clubId) => get(state, `homepage.pageData[${clubId}]`);
